import { lang } from '@lang';
import { useDesign } from '@hooks';
import { Feature, FeatureHoookParams } from '..';
import { selectSelectedAccessory, setSelectedAccessory, useAppDispatch, useAppSelector } from '@state';

type AccessoryFeatureParams = FeatureHoookParams;
export const useAddAccessoryFeature = (_params: AccessoryFeatureParams = {}): Feature<string> => {
	const [controller] = useDesign();
	const dispatch = useAppDispatch();
	const selectedAccessory = useAppSelector(selectSelectedAccessory);

	const kitchen = controller?.kitchen ?? null;

	const [disabled, tooltip] = (() => {
		if (selectedAccessory.length !== 0) return [false, lang.accessories.tooltip.addSku];
		return [true, lang.accessories.tooltip.selectSku];
	})();

	return {
		name: 'add-accessory',
		label: lang.promotionalSku.label.add,
		shortcut: '',
		tooltip,
		icon: (props = {}) => <></>,
		disabled,
		value: selectedAccessory[0],
		hidden: false,
		handler: () => {
			selectedAccessory.forEach((option) => {
				kitchen?.accessories.newSku(option);
			});
			dispatch(setSelectedAccessory([]));
		}
	};
};
